module.exports = __webpack_public_path__ + "img/zjct2.999a920d.jpg";